import type { LLMModel } from "@/hooks/api/llm"

interface EvaluatorModelOptions {
  models: LLMModel[]
  hasUnavailableSelection: boolean
}

export const getEvaluatorModelOptions = (
  availableModels: LLMModel[],
  configuredModelId: string | undefined,
  selectedModelId: string,
  unavailableLabel: string
): EvaluatorModelOptions => {
  const hasUnavailableSelection = Boolean(
    configuredModelId &&
    selectedModelId === configuredModelId &&
    !availableModels.some((model) => model.modelId === configuredModelId)
  )

  if (!hasUnavailableSelection || !configuredModelId) {
    return { models: availableModels, hasUnavailableSelection: false }
  }

  return {
    models: [
      {
        id: 0,
        modelId: configuredModelId,
        displayName: `${configuredModelId} (${unavailableLabel})`,
        provider: "",
        modelType: "text",
        inputModalities: ["text"],
        createdAt: "",
      },
      ...availableModels,
    ],
    hasUnavailableSelection: true,
  }
}
